@if( project ) {
<main>

    <h2>{{header}}</h2>

    <mat-card>
        <mat-card-header>
            <mat-card-title>Votes & Glosses</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <app-gloss-votes-donut [project]="project" [book]="bid"></app-gloss-votes-donut>
        </mat-card-content>
    </mat-card>

</main>
}